import { useEffect, useRef } from 'react';
import '../styles/ProjectPage.css'

import { initHauntedHouse } from '../scripts/threejs-hauntedhouse.js';

export default function ProjectThreeHaunted() {
    const canvasRef = useRef(null);

    useEffect(() => {
        window.scrollTo(0, 0);
        let cleanup = null;

        if (canvasRef.current) {
            // On lance la scène et on récupère la fonction de nettoyage
            cleanup = initHauntedHouse(canvasRef.current);
        }

        return () => {
            if (cleanup) cleanup();
        };
    }, []);

    return (
        <div className="project-page">
            <main className="project-main">
                <div className="webgl-wrapper">
                    <canvas ref={canvasRef} className="webgl"></canvas>
                </div>

                <div className="project-content">
                    <h1>Haunted House – Projet 3D interactif avec Three.js</h1>
                    <p className="project-desc">
                        Une scène 3D immersive représentant une maison hantée. La
                        maison, les tombes et les fantômes sont construits à partir
                        de formes primitives. Ambiance nocturne, lumières dynamiques
                        et animations organiques pour un effet réaliste et
                        mystérieux. <br />
                        Le projet a été réalisé dans le cadre de la formation
                        "Three.js Journey" de Bruno Simon.
                    </p>

                    <div className="project-tech">
                        <h3>Techno</h3>
                        <ul>
                            <li>Three.js (WebGL)</li>
                            <li>MeshStandardMaterial, textures PBR</li>
                            <li>Ombres et lumières dynamiques</li>
                            <li>Animation via tick loop</li>
                            <li>Groupes et géométries primitives</li>
                        </ul>
                    </div>
                </div>
            </main>
        </div>
    );
}